import { render } from "./banner-set.vue?vue&type=template&id=760b545e&scoped=true&ts=true"
import script from "./banner-set.vue?vue&type=script&lang=ts"
export * from "./banner-set.vue?vue&type=script&lang=ts"

import "./banner-set.vue?vue&type=style&index=0&id=760b545e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760b545e"]])

export default __exports__